"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var widgets_1 = require("@tableau/widgets");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var HeaderColumn = /** @class */ (function (_super) {
    __extends(HeaderColumn, _super);
    function HeaderColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line
        _this.state = { hovered: false };
        _this.onStartResize = function (event) {
            var resizeMouseX = widgets_1.getClientPosition(event).x;
            var node = ReactDOM.findDOMNode(_this);
            var rect = node.getBoundingClientRect();
            var initialWidth = rect.right - rect.left;
            var handleMouseMove = function (e) {
                var delta = e.clientX - resizeMouseX;
                _this.props.onColumnResize(_this.props.col, Math.max(initialWidth + delta, _this.props.minWidth));
                e.preventDefault();
            };
            var handleMouseUp = function (e) {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                e.preventDefault();
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            event.preventDefault();
        };
        _this.columnDivider = (React.createElement(widgets_1.PointerEventWrapper, { pointerDown: _this.onStartResize },
            React.createElement("div", { className: 'tb-react-dg-hdivider tb-disable-selection' })));
        _this.onClickHandler = function (e) {
            var col = _this.props.col;
            var isSortable = col.sortable !== false;
            if (isSortable && !!_this.props.onHeaderClicked) {
                _this.props.onHeaderClicked(col.dataKey, col.direction || '');
            }
            if (!_this.props.onColumnHeaderClick || _this.props.colIdx === undefined) {
                return;
            }
            var columnInfo = {
                columnIndex: _this.props.colIdx,
                columnKey: col.dataKey,
                direction: col.direction || ''
            };
            _this.props.onColumnHeaderClick(columnInfo, e);
        };
        _this.onDoubleClickHandler = function (e) {
            if (e.defaultPrevented) {
                return;
            }
            var col = _this.props.col;
            if (_this.props.onHeaderDoubleClick) {
                _this.props.onHeaderDoubleClick(col.dataKey, col.direction || '', e);
            }
        };
        _this.handleContextMenu = function (e) {
            if (_this.props.onHeaderContextMenu) {
                _this.props.onHeaderContextMenu(_this.props.col.dataKey, e);
            }
        };
        return _this;
    }
    HeaderColumn.prototype.render = function () {
        var _this = this;
        var pointerEventWrapperProps = {
            pointerClick: this.onClickHandler,
            pointerDoubleClick: this.onDoubleClickHandler
        };
        var col = this.props.col;
        var isSortable = col.sortable !== false;
        var isResizable = col.resizable !== false;
        // Determine column header classes
        var classes = ['tb-react-dg-hcell'];
        if (isSortable) {
            classes.push('tb-react-dg-hcell-sortable');
        }
        if (isResizable) {
            classes.push('tb-react-dg-hcell-resizable');
        }
        // Determine column header attributes
        var attrs = {
            className: classes.join(' '),
            onMouseEnter: function () { return _this.setState({ hovered: true }); },
            onMouseLeave: function () { return _this.setState({ hovered: false }); },
            onContextMenu: this.handleContextMenu,
            'aria-selected': this.props.isSelected
        };
        if (col.headerStyle) {
            attrs.style = col.headerStyle;
        }
        if (col.headerTooltip) {
            attrs.title = col.headerTooltip;
        }
        if (this.props.sorted) {
            attrs['data-tb-test-id'] = this.props.sortAscending ? 'data-grid-hcell-ascending' : 'data-grid-hcell-descending';
        }
        var formatter = this.props.col.headerFormatter;
        var content = formatter
            ? formatter(Utils_1.assign({}, this.props, this.state))
            : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: col.headerText, testId: col.name + '-HeaderFormatter' });
        return (React.createElement("div", { className: 'tb-react-dg-hcol', style: { width: this.props.width, minWidth: this.props.minWidth } },
            React.createElement(widgets_1.PointerEventWrapper, __assign({}, pointerEventWrapperProps),
                React.createElement("div", __assign({}, attrs), content)),
            col.resizable === false ? null : this.columnDivider));
    };
    HeaderColumn.prototype.componentDidMount = function () {
        if (!this.props.reportWidthFn) {
            return;
        }
        this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this));
    };
    HeaderColumn.displayName = 'DataGridHeaderColumn';
    HeaderColumn.element = React.createFactory(HeaderColumn);
    return HeaderColumn;
}(React.PureComponent));
exports.HeaderColumn = HeaderColumn;
//# sourceMappingURL=HeaderColumn.js.map